export default {
  'invoiceTransport.label.transport': 'Transporte',
  'invoiceTransport.label.shippingCompany': 'Transportadora',
  'invoiceTransport.label.shippingType': 'Tipo de Frete',
  'invoiceTransport.label.transportVehicle': 'Veículo de Transporte',
  'invoiceTransport.label.licensePlate': 'Placa',
  'invoiceTransport.label.uf': 'UF',
  'invoiceTransport.label.rntc': 'RNTC',
  'invoiceTransport.label.volumes': 'Volumes',
  'invoiceTransport.label.quantity': 'Quantidade',
  'invoiceTransport.label.specie': 'Espécie',
  'invoiceTransport.label.brand': 'Marca',
  'invoiceTransport.label.numbering': 'Numeração',
  'invoiceTransport.label.grossWeight': 'Peso Bruto(kg)',
  'invoiceTransport.label.netWeight': 'Peso Líquido(kg)',

  'invoiceTransport.select.sender': '0 - Por conta do Remetente',
  'invoiceTransport.select.recipient': '1 - Por conta do Destinatário',
  'invoiceTransport.select.third': '2 - Por conta de Terceiros',
  'invoiceTransport.select.senderTransport':
    '3 - Transporte Próprio por conta do Remetente',
  'invoiceTransport.select.recipientTransport':
    '4 - Transporte Próprio por conta do Destinatário',
  'invoiceTransport.select.noTransport': '9 - Sem frete',

  'invoiceTransport.dropdown.carrier': 'Transportadora',
  'invoiceTransport.button.create': 'Criar',
  'invoiceTransport.button.edit': 'Editar',

  'invoiceTransport.title.createCarrier': 'Criar Transportadora',
  'invoiceTransport.title.editCarrier': 'Editar Transportadora',

  'invoiceTransport.modal.label.socialReason': 'Razão Social',
  'invoiceTransport.modal.label.stateRegistration': 'Inscrição Estadual',
  'invoiceTransport.modal.label.personType': 'Tipo Pessoa',
  'invoiceTransport.modal.label.physical': 'Física',
  'invoiceTransport.modal.label.cpf': 'CPF',
  'invoiceTransport.modal.label.cnpj': 'CNPJ',
  'invoiceTransport.modal.label.zipCode': 'CEP',
  'invoiceTransport.modal.label.state': 'UF',
  'invoiceTransport.modal.label.city': 'Cidade',
  'invoiceTransport.modal.label.district': 'Bairro',
  'invoiceTransport.modal.label.street': 'Rua',
  'invoiceTransport.modal.label.number': 'Número',
  'invoiceTransport.modal.label.complement': 'Complemento',
  'invoiceTransport.modal.label.comments': 'Observações',

  'invoiceTransport.modal.option.natural': 'Física',
  'invoiceTransport.modal.option.legal': 'Jurídica',

  'invoiceTransport.notification.create.success.title':
    'Transportadora cadastrada com sucesso!',
  'invoiceTransport.notification.create.success.description':
    'A nova transportadora foi cadastrada com êxito.',

  'invoiceTransport.notification.remove.success.title':
    'Transportadora removida com sucesso!',
  'invoiceTransport.notification.remove.success.description':
    'A transportadora foi removida com êxito.',

  'invoiceTransport.notification.update.success.title':
    'Transportadora atualizada com sucesso!',
  'invoiceTransport.notification.update.success.description':
    'A transportadora foi atualizada com êxito.',
};
